import { FunctionComponent } from 'react';
import { FeedCard } from '../../components';
import { TagsFeedCommon } from '../../shared';

export const TagsFeed: FunctionComponent = () => {
  return <TagsFeedCommon cardComponent={(card) => <FeedCard card={card} />} />;
};
